import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = [accountNumber] as const

export type odflCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const odflDocumentTypes = [
  'appointment-confirmation',
  'corrected-bol',
  'delivery-photo',
  'detention-certificate',
  'dimension-certificate',
  'inspection-certificate',
  'invoice',
  'lumper-certificate',
  'packing-slip',
  'pickup-photo',
  'proof-of-delivery',
  'research-certificate',
  'signed-bol',
  'weight-and-research-inspection',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const odfl: CarrierDef<odflCredType> = {
  name: 'Old Dominion Freight Line',
  scac: 'odfl',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    { id: 'volume', name: 'Volume' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'ref1'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'cancel',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: odflDocumentTypes,
  credentialConfig: {
    'api-key': { hideFromFreightview: true },
    'account-number': { customerIdentifier: true },
  },
}
